var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenAp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42019",
    "data-name": "Group 42019",
    transform: "translate(-11162.572 23913.428)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3151",
    "data-name": "Rectangle 3151",
    width: 26,
    height: 26,
    rx: 13,
    transform: "translate(11162.572 -23913.428)",
    fill: "#84de87"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33652",
    "data-name": "Group 33652",
    transform: "translate(11167.761 -23908.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M7.364,12.312v-.968A5.263,5.263,0,0,0,6.207.948,5.288,5.288,0,0,0,.948,6.209,5.225,5.225,0,0,0,2.013,9.384H.876A6.205,6.205,0,1,1,7.364,12.31Z",
    transform: "translate(3.212 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33637",
    "data-name": "Group 33637",
    transform: "translate(6.789 2.492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33636",
    "data-name": "Group 33636",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_143084",
    "data-name": "Path 143084",
    d: "M283.068,67.82h-.717a2.246,2.246,0,0,0-.31-.749h1.028a.535.535,0,0,0,0-1.071h-4.186a.535.535,0,0,0,0,1.071h1.2a1.279,1.279,0,0,1,1.14.749h-2.339a.535.535,0,0,0,0,1.071h2.339a1.7,1.7,0,0,1-.246.337,1.249,1.249,0,0,1-.894.359h-1.2a.539.539,0,0,0-.535.546.553.553,0,0,0,.166.385L281.5,73.35a.534.534,0,1,0,.733-.776l-2.018-1.911a2.307,2.307,0,0,0,1.5-.669,2.4,2.4,0,0,0,.626-1.1h.717a.535.535,0,0,0,0-1.071Z",
    transform: "translate(-278.346 -66)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_143085",
    "data-name": "Path 143085",
    d: "M9.641,5.432,6.194,2.086a.3.3,0,0,0-.516.218V4.029A5.786,5.786,0,0,0,0,9.808a.3.3,0,0,0,.232.287A.29.29,0,0,0,.3,10.1.32.32,0,0,0,.579,9.94,5.173,5.173,0,0,1,5.1,7.273h.575V9a.3.3,0,0,0,.516.218L9.641,5.869a.3.3,0,0,0,0-.436Z",
    transform: "translate(0 5.557)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenAp);
export default __webpack_public_path__ + "static/media/Green_AP.f89e554ccd1ebff6c2a1238b24ba3fce.svg";
export { ForwardRef as ReactComponent };